<template>
    <div>
      <Dialog title="物品归还" :hide="editHide" @handleClick="changeClose">
        <div slot="header">物品归还</div>
        <div slot="body">
          <div class="journalBody">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="归还类型" prop="backStatus">
                <el-radio-group v-model="ruleForm.backStatus" @change="partReturnAction">
                  <el-radio label="returned">全部归还</el-radio>
                  <el-radio label="returnPart">部分归还</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="物品名称" required>
                <el-input v-model="thingName" placeholder="请输入物品名称" :disabled='!editFlag'></el-input>
              </el-form-item>
              <el-form-item label="应还数量" required>
                <el-input v-model="notReturnedCount" placeholder="请输入应还数量" maxlength="8" :disabled='!editFlag'></el-input>
              </el-form-item>
              <el-form-item label="归还数量" prop="backCount" :rules="$rules.zeroNumed">
                <el-input v-model="ruleForm.backCount" placeholder="请输入归还数量" maxlength="8"></el-input>
              </el-form-item>
              <el-form-item label="归还日期" required>
                <el-col :span="11">
                <!-- <el-col :span="11"> -->
                  <el-form-item prop="backTime">
                    <!-- <el-date-picker
                      type="date"
                      placeholder="请选择归还日期"
                      v-model="ruleForm.backTime"
                      style="width: 100%;"
                    ></el-date-picker> -->
                    <el-date-picker
                      v-model="ruleForm.backTime"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="请选择归还日期"
                      popper-class="el-date-picker"
                      style="width: 100%;"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="归还技师" prop="staffId">
                <el-select v-model="ruleForm.staffId" placeholder="请选择归还技师">
                    <el-option
                      v-for="(item,index) in staffList"
                      :key="index"
                      :label="item.staffName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="备注" prop="remark">
                <el-input type="textarea" :maxlength="100" v-model="ruleForm.remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div slot="footer">
          <el-button @click="cancelAciton">取 消</el-button>
          <el-button type="primary" @click="trueAction">确 定</el-button>
        </div>
      </Dialog>
    </div>
  </template>
  
  <script>
  import minxin from "../../../assets/javascript/minxin.js";
  import Dialog from "../../../components/common/dialog.vue";
  export default {
      data() {
        return {
          editHide: false,
          editFlag: false,
          thingName: '',
          notReturnedCount: '',
          ruleForm: {
            borrowId: '',
            backStatus: 'returned',
            backCount: '',
            backTime: '',
            staffId: '',
            staffName: '',
            remark: '',
          },
          rules: {
            backStatus: [
              { required: true, message: '请选择归还类型', trigger: 'change' }
            ],
            backCount: [
              { required: true, message: '请输入归还数量', trigger: 'change' }
            ],
            backTime: [
              { required: true, message: '请选择归还日期', trigger: 'change' }
            ],
            staffId: [
              // { type: 'array', required: true, message: '请选择借领技师', trigger: 'change' }
              { required: true, message: '请选择归还技师', trigger: 'change' }
            ],
            remark: [
              { required: false, message: '请输入备注', trigger: 'blur' }
            ]
          },
          staffList: [], //店员列表
        };
      },
      mixins: [minxin],
      components:{Dialog},
      created(){
          this.init();
      },
      methods: {
        init(){
            this.$on('set', function (org) {
                this.editHide = true;
                
                this.ruleForm.borrowId = org.id;
                this.ruleForm.backTime = '';
                this.ruleForm.backCount = org.notReturnedCount;
                this.ruleForm.staffId = org.staffId;
                this.ruleForm.staffName = org.staffName;
                this.ruleForm.remark = '';
                this.thingName = org.thingName;
                this.notReturnedCount = org.notReturnedCount;

                this.cardOldList();
            });
          },
        cardOldList() {
          this.$api.get(this.$url.companyStaff.list, {filterStatus: 'disable'}).then(res => {
            if (res) {
              this.staffList = res;
            }
          })
        },
        changeClose(show){
            this.editHide = false;
            this.thingName = '';
            this.notReturnedCount = '';
            this.ruleForm = {
              borrowId: '',
              backStatus: 'returned',
              backCount: '',
              backTime: '',
              staffId: '',
              staffName: '',
              remark: '',
            };
            this.$refs['ruleForm'].resetFields();
            this.$emit('borrowBackChange',false);
        },
        cancelAciton() {
          this.editHide = false;
        },

        partReturnAction(value) {
          if (value == "returnPart") {
            this.ruleForm.backCount = '';
          }
        },
        handleStaffChange(item) {
          this.ruleForm.staffName = item.staffName;
          this.ruleForm.staffId = item.id;
      },

        trueAction() {
          if (Number(this.ruleForm.backCount) == Number(0)) {
            this.$message.warning('归还数量不能为0');
            return false;
          }
          if (Number(this.ruleForm.backCount) > Number(this.notReturnedCount)) {
            this.$message.warning('归还数量不能大于应还数量');
            return false;
          }
          if (this.ruleForm.backTime == '') {
            this.$message.warning('归还日期不能为空');
            return false;
          }
         if (this.ruleForm.staffName == '') {
          this.$message.warning('借领技师不能为空');
            return false;
          }
          if (this.ruleForm.backStatus == 'returned') {
            if (Number(this.ruleForm.backCount) < Number(this.notReturnedCount)) {
              if (this.ruleForm.remark == '') {
                this.$message.warning('请输入备注');
               return false;
             }
            }
          }

         this.staffList.map((item) => {
          if (this.ruleForm.staffId == item.id) {
            this.ruleForm.staffName = item.staffName;
          }
        });

        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.$api.post(this.$url.staffBorrowInfo.borrowBackSave, this.ruleForm).then(res => {
              if (res) {
                this.editHide = false;
                this.thingName = '';
                this.notReturnedCount = '';
                this.ruleForm = {
                  borrowId: '',
                  backStatus: 'returned',
                  backCount: '',
                  backTime: '',
                  staffId: '',
                  staffName: '',
                  remark: '',
                };
                this.$refs['ruleForm'].resetFields();
                this.$refs.ruleForm.resetFields();
                this.$message.success("归还成功");
                this.$emit("borrowBackChange", true);
              }
            }).catch(error => {

            })
          } else {
            return false;
          }
        });
        },
      }
    }
  </script>
  
  <style scoped lang="less">
  
  /deep/ .el-dialog {
    margin-top: 0 !important;
    height: 600px;
    top: calc(50% - 300px);
    border-radius: 10px;
  }
  
  /deep/ .el-dialog__body {
    padding: 0 !important;
    .bodys {
      box-sizing: border-box;
      padding: 24px 0;
      height: 475px;
    }
  }
  
  // .demo-ruleForm {
  //   height: 400px;
  // }
  
  .journalBody {
    padding: 20px;
  }
  .down-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .down-img img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .journaltitle {
    font-size: 19px;
    font-weight: bold;
    color: #111;
    margin-bottom: 15px;
  }
  
  .time {
    margin-top: 7.5px;
    font-size: 12px;
    color: #999;
  }
  
  .mains {
    margin-top: 32px;
    margin-left: 40px;
  }
  .f16 {
    font-size: 16px;
  }
  
  
  
  </style>
  